import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Heading from 'components/shared/heading';
import Button from 'components/shared/button';

import styles from './hero-with-large-image.module.scss';

const cx = classNames.bind(styles);

const HeroWithLargeImage = ({ title, description, buttontext, buttonurl, image }) => (
  <section className={cx('wrapper')}>
    <div className="container">
      <Heading className={cx('title')} color="tertiary" size="xl">
        {title}
      </Heading>
      <p className={cx('description')}>{description}</p>
      {buttontext && buttonurl && (
        <Button className={cx('button')} to={buttonurl} theme="tertiary">
          {buttontext}
        </Button>
      )}

      <div className={cx('image-wrapper')}>
        <img className={cx('image')} src={image} alt="" loading="eager" fetchPriority="high" />
      </div>
    </div>
  </section>
);

HeroWithLargeImage.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttontext: PropTypes.string.isRequired,
  buttonurl: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
};

export default HeroWithLargeImage;
